import React from 'react';
import { GiftIcon } from 'lucide-react';
import { formatPrice } from '../data/config';
type BonusCardProps = {
  number: string;
  title: string;
  price: number;
  points: string[];
  finalLine: string;
  showReferencePrice: boolean;
};
export function BonusCard({
  number,
  title,
  price,
  points,
  finalLine,
  showReferencePrice
}: BonusCardProps) {
  const [lead, ...rest] = points;
  return <article className="rounded-md border-l-[5px] border-amber-400 bg-white px-3.5 py-3 text-left md:px-4" data-id="element-10" data-mp="20ezkprd0tzm9">
      <h3 className="flex items-start gap-2 text-sm font-extrabold uppercase leading-tight text-blue-950 md:text-base" data-id="element-11" data-mp="25crekqx87vt3">
        <GiftIcon className="mt-px h-4 w-4 shrink-0 text-amber-700" strokeWidth={2.5} aria-hidden data-id="element-12" data-mp="29ecmryytflwy" />
        <span data-id="element-13" data-mp="2e6ntplrz47z0">
          Bono {number} — {title}
        </span>
      </h3>
      <p className="mt-1 text-sm font-bold leading-snug text-sky-600" data-id="element-14" data-mp="1horntqzx05ei">{lead}</p>
      <p className="mt-0.5 flex flex-wrap items-center gap-2 text-xs font-extrabold uppercase" data-id="element-15" data-mp="1lpblcvoehb16">
        {showReferencePrice && <s className="font-semibold text-slate-400" data-id="element-16" data-mp="1x2eflkgfsuyd">{formatPrice(price)}</s>}
        <span className="text-green-600" data-id="element-17" data-mp="1s3a60splov7i">Gratis con tu compra</span>
      </p>
      <div className="mt-1 space-y-1 text-sm leading-snug text-slate-600 md:text-base" data-id="element-18" data-mp="1s5e6t1s7de3k">
        {rest.map(p => <p key={p} data-id="element-19" data-mp="1idi8bpm7flyt">{p}</p>)}
      </div>
      <p className="mt-1.5 text-xs font-extrabold uppercase leading-tight text-amber-700 md:text-sm" data-id="element-20" data-mp="1icpa5d1ba4sa">{finalLine}</p>
    </article>;
}